import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useP } from '../../../i18n/useP';
import { PRESETS } from './presets';

// Dropdown trigger "+ Ajouter une ligne" → blank row or one of the 7 presets.
// Closes on outside click, Escape key, or item selection.
export default function AddRevenueMenu({ onSelectBlank, onSelectPreset, onLoadStandardPack, disabled = false }) {
  const { t } = useTranslation();
  const p = useP();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    function handleKey(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open]);

  function pickBlank() {
    setOpen(false);
    onSelectBlank();
  }

  function pickPreset(presetId) {
    setOpen(false);
    onSelectPreset(presetId);
  }

  return (
    <div className="billing-add-menu" ref={wrapperRef}>
      <button
        type="button"
        className="billing-add-menu__trigger"
        onClick={() => setOpen((v) => !v)}
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="billing-add-menu__trigger-plus" aria-hidden="true">+</span>
        {p('Ajouter une ligne')}
        <span className="billing-add-menu__chevron" aria-hidden="true">▾</span>
      </button>

      {open && (
        <div className="billing-add-menu__dropdown" role="menu">
          {onLoadStandardPack && (
            <>
              <button
                type="button"
                role="menuitem"
                className="billing-add-menu__item billing-add-menu__item--standard"
                onClick={() => { setOpen(false); onLoadStandardPack(); }}
              >
                <span className="billing-add-menu__item-label">{p('Charger le jeu standard')}</span>
                <span className="billing-add-menu__item-desc">
                  {p("9 lignes types PME services : Conseil, Forfait, Abonnement, Carnet d'heures, Licences, Outsourced, Hardware/Software, Commissions, Autres.")}
                </span>
              </button>
              <div className="billing-add-menu__divider" />
            </>
          )}

          <button
            type="button"
            role="menuitem"
            className="billing-add-menu__item billing-add-menu__item--compact billing-add-menu__item--blank"
            onClick={pickBlank}
            title={t('phrases:p_0793669379')}
          >
            <span className="billing-add-menu__item-label">{p('Ligne vierge')}</span>
          </button>

          <div className="billing-add-menu__divider" />

          <div className="billing-add-menu__section-label">{p('Presets de revenus')}</div>

          {PRESETS.map((preset) => (
            <button
              key={preset.id}
              type="button"
              role="menuitem"
              className="billing-add-menu__item billing-add-menu__item--compact"
              onClick={() => pickPreset(preset.id)}
              title={preset.description}
            >
              <span className="billing-add-menu__item-label">{preset.labelFr}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
